import * as types from "./types";
import { menusApi } from "@apiService";

export const getMenus = (slug) => {
  return {
    type: types.GET_MENUS,
    payload: menusApi.getMenu(slug),
  };
};
